import { render, staticRenderFns } from "./Productstation.vue?vue&type=template&id=56da2bfc&"
import script from "./Productstation.vue?vue&type=script&lang=js&"
export * from "./Productstation.vue?vue&type=script&lang=js&"
import style0 from "./Productstation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports